<script setup lang="ts">
    import { bsAlert } from './BsAlerts';

    const props = defineProps<{
        textToCopy: string;
        buttonText?: string;
        tooltip?: string;
    }>();

    function copy(): void {
        navigator.clipboard
            .writeText(props.textToCopy)
            .then(() => bsAlert({ title: $Resources.copyToClipboardAlertHeading, content: $Resources.copyToClipboardAlertText, type: 'success' }));
    }
</script>

<template>
    <button @click="copy" class="btn btn-default btn-sm" v-tooltip.top="props.tooltip">
        <!-- <i class="fas fa-copy"></i> -->
        {{ props.buttonText || $Resources.CopyBtn }}
    </button>
</template>
